import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function blockUser(userIds) {
	return fetch(
		`${ENDPOINT_URL}/blockusers`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				ids: userIds,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
